const HEADING_PATTERN = /^\s{0,3}(#{1,6})\s+(.*)$/;
const BULLET_PATTERN = /^\s{0,3}[-*+]\s+(.*)$/;
const NUMBERED_PATTERN = /^\s{0,3}(\d{1,3})[.)]\s+(.*)$/;
const EMPHASIS_SPLIT = /(\*\*[^*]+\*\*|__[^_]+__|\*[^*]+\*|_[^_]+_|`[^`]+`)/;
const STRONG_MARKS = ["**", "__"];
const PLAIN_MARKS = ["*", "_", "`"];

const BLOCK_PARAGRAPH = "paragraph";
const BLOCK_HEADING = "heading";
const BLOCK_BULLET = "bullet";
const BLOCK_NUMBERED = "numbered";

function runOf(token) {
  for (const mark of STRONG_MARKS) {
    if (token.length > mark.length * 2 && token.startsWith(mark) && token.endsWith(mark)) {
      return { text: token.slice(mark.length, -mark.length), strong: true };
    }
  }
  for (const mark of PLAIN_MARKS) {
    if (token.length > 2 && token.startsWith(mark) && token.endsWith(mark)) {
      return { text: token.slice(1, -1), strong: false };
    }
  }
  return { text: token, strong: false };
}

function runsOf(line) {
  const runs = line
      .split(EMPHASIS_SPLIT)
      .filter(token => token !== "" && token !== undefined)
      .map(runOf)
      .filter(run => run.text !== "");
  return runs.length > 0 ? runs : [{ text: "", strong: false }];
}

function blockOf(line) {
  const heading = HEADING_PATTERN.exec(line);
  if (heading) {
    return { type: BLOCK_HEADING, level: heading[1].length, marker: "", runs: runsOf(heading[2]) };
  }
  const numbered = NUMBERED_PATTERN.exec(line);
  if (numbered) {
    return { type: BLOCK_NUMBERED, level: 0, marker: `${numbered[1]}.`, runs: runsOf(numbered[2]) };
  }
  const bullet = BULLET_PATTERN.exec(line);
  if (bullet) {
    return { type: BLOCK_BULLET, level: 0, marker: "•", runs: runsOf(bullet[1]) };
  }
  return { type: BLOCK_PARAGRAPH, level: 0, marker: "", runs: runsOf(line) };
}

function markdownBlocks(value) {
  if (typeof value !== "string" || value.trim() === "") {
    return [];
  }

  const blocks = [];
  let openParagraph = null;
  value.split(/\r?\n/).forEach(rawLine => {
    const line = rawLine.trim();
    if (line === "") {
      openParagraph = null;
      return;
    }
    const block = blockOf(line);
    if (block.type === BLOCK_PARAGRAPH && openParagraph) {
      openParagraph.runs.push({ text: " ", strong: false }, ...block.runs);
      return;
    }
    blocks.push(block);
    openParagraph = block.type === BLOCK_PARAGRAPH ? block : null;
  });

  return blocks;
}

module.exports = {
  markdownBlocks,
  BLOCK_PARAGRAPH,
  BLOCK_HEADING,
  BLOCK_BULLET,
  BLOCK_NUMBERED,
};
